import React from 'react'
import { Link } from 'react-router-dom'
import Check from '../../../assets/images/shop/product-slider-1.jpg'

const CheckOut = () => {
    return (
        <>
            <div className="checkout-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="checkout-form">
                                <form action="#">
                                    <div className="form-group-outer">
                                        <div className="form-group-inner mb-0">
                                            <label>
                                                First name&nbsp;<span>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="First Name"
                                                className="form-control"
                                                required=""
                                            />
                                        </div>
                                        <div className="form-group-inner mb-0">
                                            <label>
                                                Last name&nbsp;<span>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="lastname"
                                                placeholder="Last Name"
                                                className="form-control"
                                                required=""
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="form-group-inner">
                                            <label>Company name&nbsp;(optional)</label>
                                            <input
                                                type="text"
                                                name="company"
                                                placeholder="Company"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group-inner">
                                            <input
                                                type="text"
                                                name="country"
                                                placeholder="United State (US)"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group-inner">
                                            <input
                                                type="text"
                                                name="address"
                                                placeholder="House number street name"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group-inner">
                                            <input
                                                type="text"
                                                name="address2"
                                                placeholder="Apparent,unit "
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Town / City<span>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="address3"
                                            placeholder="Town city"
                                            className="form-control"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            State&nbsp;<span>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="address4"
                                            placeholder="california"
                                            className="form-control"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Zip Code&nbsp;<span>*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="address5"
                                            placeholder="ZIP code"
                                            className="form-control"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Phone&nbsp;<span>*</span>
                                        </label>
                                        <input
                                            type="number"
                                            name="address6"
                                            placeholder="Phonu Number"
                                            className="form-control"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>
                                            Email&nbsp;<span>*</span>
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Email Address"
                                            className="form-control"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Additional information</label>
                                        <textarea
                                            name="nots"
                                            placeholder="Notes about your order, e.g. special notes for delivery."
                                            className="form-control"
                                            rows={6}
                                            defaultValue={""}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="place-order-box">
                                <h4>Your Order</h4>
                                <div className="order-product-info">
                                    <img
                                        height={130}
                                        src={Check}
                                        alt="product-image"
                                    />
                                    <h6>Hangbag</h6>
                                </div>
                                <div className="order-info">
                                    <ul>
                                        <li>
                                            <p>Pricing :&nbsp;</p>
                                            <span>$25</span>
                                        </li>
                                        <li>
                                            <p>Shipping :&nbsp;</p>
                                            <span>$07</span>
                                        </li>
                                        <li>
                                            <p>Total :&nbsp;</p>
                                            <span>$32</span>
                                        </li>
                                    </ul>
                                    <form action="#" className="payment-option">
                                        <div className="form-group-option">
                                            <input
                                                type="radio"
                                                id="bankTransfer"
                                                name="paymentMethod"
                                                defaultValue="bankTransfer"
                                            />
                                            <p>Direct Bank Transfer</p>
                                        </div>
                                        <div className="form-group-option">
                                            <input
                                                type="radio"
                                                id="cash"
                                                name="paymentMethod"
                                                defaultValue="cash"
                                            />
                                            <p>Cash On Delivery</p>
                                        </div>
                                    </form>
                                    <Link to="#" className="btn btn-primary btn-theme">
                                        Place Your Order
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CheckOut
